import i18n from 'i18next';
import { useEffect } from 'react';
import { LocalStorageItems } from 'shared/constants';
import localesMap from 'shared/i18n/localesMap';
import { Tenant } from 'shared/types';

export default function useActualizeTenantLanguage(tenant: Tenant | null) {
    useEffect(() => {
        const language = getLanguageFromStorage() ?? getLanguageFromTenant(tenant);

        if (!language) {
            return;
        }

        if (language && i18n.language !== language) {
            i18n.changeLanguage(language);
        }
    }, [ tenant ]);
}

function getLanguageFromStorage() {
    return localStorage.getItem(LocalStorageItems.SELECTED_LANGUAGE);
}

function getLanguageFromTenant(tenant: Tenant | null) {
    if (!tenant?.countryCode) {
        return null;
    }

    return Object.entries(localesMap).find(([ , localeDetails ]) =>
        localeDetails.countryCodes.includes(tenant.countryCode)
    )?.[0];
}
